// extracted by mini-css-extract-plugin
export default {"modalBody":"app-react-components-modals-Modal-ModalBody-module__modal-body"};